import { useEffect, useState } from 'react';
import { Input, Range } from '@paysera/ui';
const DualRangeSlider = ({ preffix, minRange, maxRange, minValue, maxValue, label, minLabel, maxLabel, step = 1, onMinChange, onMaxChange, }) => {
    const [minInputValue, setMinInputValue] = useState(minValue.toString());
    const [maxInputValue, setMaxInputValue] = useState(maxValue.toString());
    useEffect(() => {
        setMinInputValue(minValue.toString());
    }, [minValue]);
    useEffect(() => {
        setMaxInputValue(maxValue.toString());
    }, [maxValue]);
    const handleRangeChange = (value) => {
        onMinChange(value[0]);
        onMaxChange(value[1]);
    };
    const handleMinChange = (value) => {
        const numValue = Number(value);
        setMinInputValue(value);
        if (!Number.isNaN(numValue) &&
            numValue >= minRange &&
            numValue <= maxRange &&
            numValue <= maxValue &&
            numValue % step === 0) {
            onMinChange(numValue);
        }
    };
    const handleMaxChange = (value) => {
        const numValue = Number(value);
        setMaxInputValue(value);
        if (!Number.isNaN(numValue) &&
            numValue >= minRange &&
            numValue <= maxRange &&
            numValue >= minValue &&
            numValue % step === 0) {
            onMaxChange(numValue);
        }
    };
    const validateMinValue = () => {
        const numValue = Number(minInputValue);
        if (Number.isNaN(numValue)) {
            setMinInputValue(minValue.toString());
            return;
        }
        let newMinValue = numValue;
        if (numValue < minRange) {
            newMinValue = minRange;
        }
        else if (numValue > maxRange) {
            newMinValue = maxRange;
        }
        else {
            newMinValue = numValue;
        }
        onMinChange(newMinValue);
        setMinInputValue(newMinValue.toString());
    };
    const validateMaxValue = () => {
        const numValue = Number(maxInputValue);
        if (Number.isNaN(numValue)) {
            setMaxInputValue(maxValue.toString());
            return;
        }
        let newMaxValue = numValue;
        if (numValue > maxRange) {
            newMaxValue = maxRange;
        }
        else if (numValue < minRange) {
            newMaxValue = minRange;
        }
        else {
            newMaxValue = numValue;
        }
        onMaxChange(newMaxValue);
        setMaxInputValue(newMaxValue.toString());
    };
    return (<div className="flex flex-col gap-4">
            <Range label={label} isTwoHandles min={minRange} max={maxRange} step={step} value={[minValue, maxValue]} onChange={handleRangeChange}/>
            <div className="flex justify-between gap-2">
                <Input className="w-full" id={`${preffix}MinValue`} type="number" label={minLabel} step={step} value={minInputValue} onChange={(event) => handleMinChange(event.target.value)} onBlur={validateMinValue}/>
                <Input className="w-full" type="number" id={`${preffix}MaxValue`} label={maxLabel} step={step} value={maxInputValue} onChange={(event) => handleMaxChange(event.target.value)} onBlur={validateMaxValue}/>
            </div>
        </div>);
};
export default DualRangeSlider;
